import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pd0004',
    ecrans: ['00-2']
});
